<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div slot="header">
        <span>1. 填写开班单位名称</span>
      </div>

      <div class="form_box__item">
        <div class="form_box__item__input">
          <el-input v-model="title" placeholder="请输入开班单位名称" ref="input_title"></el-input>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="publish">发布</el-button>
      <el-button style="margin-top: 12px;" type="info" @click="temporaty">暂存</el-button>
    </el-card>
  </div>
</template>



<script>
import { BaseVue } from "@/mixin/index";
import { classunitAddApi } from "@/api/module/classunit/classunit";

export default {
  name: "ClassunitAdd",
  
  mixins: [BaseVue],
  
  data() {
    return {
      title: "",
      loading: false,
      status: ""
    };
  },
  
  methods: {
    publish() {
      this.loading = true;
      this.status = "0";
      this.addDemo();
    },
    
    temporaty() {
      this.loading = true;
      this.status = "1";
      this.addDemo();
    },
    
    addDemo() {
      const data = {
        title: this.title,
        status: this.status
      };
      
      classunitAddApi(data)
        .then(response => {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          setTimeout(() => {
            this.$router.replace({
              path: '/standard/classunit/dashboard'
            });
          }, 1500);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>

<style scoped>
</style>

